import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { convertBaggageObject } from '../../../Checkout/types';
import BaggageIcon from '../../../Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import UpsaleItem from '@features/upsale/ui/UpsaleItem/UpsaleItem';
import AiPredictionFooter from '../AiPredictionFooter/AiPredictionFooter';
const AiPurchasePredictionBaggage = ({ item, onChange, onDisagree, onAgree }) => {
    const { t } = useTranslation('AIPurchasePredictionService');
    const baggage = useMemo(() => {
        return convertBaggageObject(item);
    }, [item]);
    const service = useMemo(() => ({
        price: baggage.price,
        name: baggage.name,
        header: React.createElement(BaggageIcon, { realSize: true, baggage: baggage }),
        description: React.createElement("span", null, baggage.description)
    }), [baggage]);
    return (React.createElement(React.Fragment, null,
        React.createElement(UpsaleItem, { title: t('Looks like you forgot to add your baggage'), service: service, onChange: onChange, footer: React.createElement(AiPredictionFooter, { text: t('Continue without baggage'), onDisagree: onDisagree, onAgree: onAgree }) })));
};
export default AiPurchasePredictionBaggage;
